/** @jsxRuntime classic */
// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function BottleVariant({ bottleVariant, ...rest }) {
  if (!bottleVariant) return null;
  const { eanBottle, bottleSize } = bottleVariant;
  if (!eanBottle && !bottleSize) return null;

  return (
    <Section title={<Trans>Bottle</Trans>} {...rest}>
      <Text>{eanBottle}</Text>
      <Text>{bottleSize}</Text>
    </Section>
  );
}

export const fragment = graphql`
  fragment BottleVariant on ProductBottleVariant {
    eanBottle
    bottleSize
  }
`;

BottleVariant.fragment = gql`
  fragment BottleVariant on ProductBottleVariant {
    eanBottle
    bottleSize
  }
`;
